'use client';

import { useSearchParams } from 'next/navigation';
import { BottomNav } from './BottomNav';

export function ConditionalBottomNav() {
  const searchParams = useSearchParams();
  const chatId = searchParams.get('chat_id');
  const unitSlug = searchParams.get('unit_slug');

  // Hide bottom nav when viewing a specific chat message
  if (chatId && unitSlug) {
    return null;
  }

  return <BottomNav />;
}
